export default "__VITE_ASSET__CvSm6o8w__"